import { render, staticRenderFns } from "./Noke.vue?vue&type=template&id=663cc582&scoped=true&"
import script from "./Noke.vue?vue&type=script&lang=js&"
export * from "./Noke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663cc582",
  null
  
)

export default component.exports